<template>
    <div class="modal-window uts004 uts000">
        <header class="modal-header">
            <div class="tit">
                <span @click="changeTab(1)" style="cursor: pointer;" :style="tab1 ? 'color: #000;':'color: #d9d9d9;'" >{{$i18nUtil.trans("title.TodoTeam.001","팀원 할 일 현황")}}</span>
                <div v-if="roleTLDTypeUser && tenantId=='203'" class="dividing_line_ty1"></div>
                <span v-if="roleTLDTypeUser && tenantId=='203'" @click="changeTab(2)" style="cursor: pointer;" :style="tab2 ? 'color: #000;':'color: #d9d9d9;'">{{$i18nUtil.trans("title.TodoTeam.002","팀원 과제/보드 현황")}}</span>
            </div>
        </header>
        
        <div class="modal-content">
            <div class="tab_ty1" id="tabsTy3">
                <div class="tab-content">
                    <div>
                        <div class="tab_ty2" id="tabsTy4">
                            <div class="tab-content">
                                <div>
                                    <div class="tb-header">
                                        <div>
                                            <!-- 부서 목록이 2개 이상인 사용자 -->
                                            <div :class="roleTypeUser || gdpUser ? 'team-name dropdown relative ty1' : 'not-organ team-name dropdown relative ty1'" v-if="deptListSize > 1">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" class="ell-singleline">{{currentDeptName}}</v-btn>
                                                    </template>
                                                    <div class="dropdown-list">
                                                        <div class="scroll">
                                                            <div class="dropdown-list-item" v-for="(tab, index) in deptList" :key="'dept' + index">
                                                                <div class="tit">
                                                                    <button type="button"
                                                                    :class="tab.split(':')[1] == currentDeptId ? 'ell-singleline active' : 'ell-singleline'"
                                                                     @click="changeDept(tab)">{{tab.split(":")[0]}}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-menu>
                                            </div>
                                            <!-- 일반 사용자 -->
                                            <div :class="roleTypeUser || gdpUser ? 'team-name dropdown relative ty1 ell-singleline' : 'not-organ team-name dropdown relative ty1 ell-singleline'" v-else>{{currentDeptName}}</div>

                                            <div class="droplayer icon organ large left ty3 nosel" v-if="roleTypeUser || gdpUser">
                                            <!-- <div class="droplayer icon organ large left ty3 nosel"> -->
                                                <v-menu bottom left :close-on-content-click="false">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on">조직도</v-btn>
                                                    </template>
                                                    <div class="dropdown-list">
                                                        <template class="tree-area">
                                                            <div class="treeselect">
                                                                <treeselect
                                                                :max-height="250"
                                                                :options="treeData"
                                                                :default-expand-level="1"
                                                                :always-open="alwaysOpen"
                                                                :open-on-click="openOnClick"
                                                                :load-options="handleOpenNode"
                                                                :noOptionsText="$i18nUtil.trans('search.041')"
                                                                :loadingText="$i18nUtil.trans('search.042')"
                                                                :noChildrenText="$i18nUtil.trans('search.043')"
                                                                @select="handleSelectNode"
                                                                @deselect="handleDeSelectNode"
                                                                />
                                                            </div>
                                                        </template>
                                                    </div>
                                                </v-menu>
                                            </div>

                                            <template v-if="tab1">
                                                <input type="radio" name="perform" id="perform1" value="1" v-model="perform" @change="searchClick"><label for="perform1">{{ $i18nUtil.trans("entity.todo.filter.executionPeriod","수행기간") }}</label>
                                                <input type="radio" name="perform" id="perform2" value="2" v-model="perform" @change="searchClick"><label for="perform2">{{ $i18nUtil.trans("entity.todo.filter.completionDate","완료일") }}</label>
                                                <div class="dividing_line_ty1"></div>
                                                <div class="radio-wrap">
                                                    <input type="radio" class="custom-radio" name="period" id="name1" checked @click="daySel"><label for="name1">{{ $i18nUtil.trans("entity.todo.filter.day","일") }}</label>
                                                    <input type="radio" class="custom-radio" name="period" id="name2" @click="weekSel"><label for="name2">{{ $i18nUtil.trans("entity.todo.filter.week","주") }}</label>
                                                </div>
                                                <div class="dropdown relative ty1-custom" v-if="quarterSelYn === 'N'">
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn v-bind="attrs" style="width:120px" @click="quarterSelBtn" v-if="quarterSelYn === 'N'">{{quarterName}}</v-btn>
                                                            <v-btn v-bind="attrs" v-on="on" style="width:120px;" v-else>{{quarterName}}</v-btn>
                                                        </template>
                                                        <div class="dropdown-list">
                                                            <div class="scroll">
                                                                <div class="dropdown-list-item" v-for="(item, index) in quarter" :key="'pattern' + index" @click="quarterSel(item, index)">
                                                                    <div class="tit"><button type="button" v-bind:class="{ active: currentIndex === index }">{{item.quarterName}}</button></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-menu>
                                                </div>
                                                <div class="dropdown relative ty1-custom active" v-else>
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn v-bind="attrs" style="width:120px" @click="quarterSelBtn" v-if="quarterSelYn === 'N'">{{quarterName}}</v-btn>
                                                            <v-btn v-bind="attrs" v-on="on" style="width:120px;" v-else>{{quarterName}}</v-btn>
                                                        </template>
                                                        <div class="dropdown-list">
                                                            <div class="scroll">
                                                                <div class="dropdown-list-item" v-for="(item, index) in quarter" :key="'pattern' + index" @click="quarterSel(item, index)">
                                                                    <div class="tit"><button type="button" v-bind:class="{ active: currentIndex === index }">{{item.quarterName}}</button></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-menu>
                                                </div>
                                                <div class="calendar_box_grp small">
                                                    <div class="calendar_box">
                                                        <datepicker 
                                                            format="yyyy.MM.dd" 
                                                            v-model="dateFrom"
                                                            :disabled="dayGbn === '0'"
                                                            @selected="dateFromChange">
                                                        </datepicker>
                                                    </div>
                                                    <span>~</span>
                                                    <div class="calendar_box">
                                                        <datepicker 
                                                            format="yyyy.MM.dd" 
                                                            v-model="dateTo"
                                                            :disabled="dayGbn === '0'"
                                                            @selected="dateToChange">
                                                        </datepicker>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="tab2">
                                                <input type="radio" name="changeSelect" id="changeSelect1" value="1" v-model="changeSelect" @change="searchClick2"><label for="changeSelect1">{{ $i18nUtil.trans("title.TodoTeam.006","과제목록") }}</label>
                                                <input type="radio" name="changeSelect" id="changeSelect2" value="2" v-model="changeSelect" @change="searchClick2"><label for="changeSelect2">{{ $i18nUtil.trans("title.TodoTeam.007","보드목록") }}</label>
                                            </template>
                                        </div>

                                        <template v-if="tab1">
                                            <div>
                                                <input type="checkbox" name="" id="comp1" v-model="comp1" @change="searchClick"><label for="comp1">{{ $i18nUtil.trans("entity.todo.status.incomplete","미완료") }}</label>
                                                <input type="checkbox" name="" id="comp2" v-model="comp2" @change="searchClick"><label for="comp2">{{ $i18nUtil.trans("entity.todo.status.completed","완료") }}</label>
                                                <div class="dividing_line_ty1"></div>
                                                <button type="button" class="btn-primary-small black" @click="getTodoTeamExcelDownload">{{ $i18nUtil.trans("button.excel.download","엑셀다운로드") }}</button>
                                            </div>
                                        </template>
                                    </div><!-- //tb-header -->

                                    <div class="team-wrap">
                                        <div class="team-list">
                                            <ul class="scroll" id="scrollTeam">
                                                <li v-for="(item, index) in todoTeamList" :key="'team' + index" :class="selectedUserIndex === index?'active':''">
                                                    <button type="button" @click="todoUserClick(index)">
                                                        <span class="name">{{item.USER_NAME}}</span>
                                                        <span class="num" v-html="$i18nUtil.trans('search.000.cnt','{cnt}건', {cnt: item.TODO_COUNT})"></span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="team-board">
                                            <div class="scroll" id="scrollUser">
                                                <v-data-table
                                                    v-model="selected"
                                                    :headers="selectHeader"
                                                    :items="todoUserList"
                                                    :sort-by.sync="sortBy"
                                                    :sort-desc.sync="sortDesc"
                                                    :must-sort="true"
                                                    :single-select="singleSelect"
                                                    :items-per-page="itemsPerPage"
                                                    hide-default-footer
                                                    class="tb-contents" :class="tab2 && changeSelect==1 ? 'uts004_1_table':'uts004_table'">

                                                    <template v-slot:[`item.paperTitle`]="{ item }">
                                                        <div class="cursor-pointer multi-ellipsis"
                                                            @click="moveLocation(item.paperId)"
                                                            v-if="tab1 && item.paperTitle !== null">
                                                            {{ item.paperTitle }}
                                                        </div>
                                                        <div v-if="tab2 && changeSelect == 2" class="multi-ellipsis-one" :title="item.paperTitle">
                                                            {{item.paperTitle}}
                                                        </div>
                                                    </template>

                                                    <template v-if="tab1" v-slot:[`item.todoTitle`]="{ item }">
                                                        <div class="cursor-pointer multi-ellipsis d-block" 
                                                            v-html="item.todoTitle.split('\n').join('<br />')"
                                                            @click="todoInfoOpen(item)">
                                                        </div>
                                                    </template>
                                                    
                                                    <template v-if="tab1" v-slot:[`item.regUserName`]="{ item }">
                                                        <div class="re-de">
                                                            <div class="re">
                                                                <div class="droplayer tooltipmember relative right">
                                                                    <v-menu offset-y>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn v-bind="attrs" v-on="on">
                                                                                <b v-if="item.regUserId != userInfo.userId">{{ item.regUserName }}</b>
                                                                                <b v-else></b>
                                                                            </v-btn>
                                                                        </template>
                                                                        <div class="dropdown-list">
                                                                            <UserTooltip
                                                                            :userId="item.regUserId"
                                                                            />
                                                                        </div>
                                                                    </v-menu>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    
                                                    <template v-if="tab1" v-slot:[`item.todoEndDate`]="{ item }">
                                                        <div :class="
                                                            $moment($moment(item.todoEndDate).format('YYYY.MM.DD')).diff($moment(new Date()).format('YYYY.MM.DD'), 'days') <= 3
                                                            ? item.todoStatus === 'P' ? 'deadline':''
                                                            : ''
                                                        ">
                                                            ~{{ $moment(item.todoEndDate).format('YYYY.MM.DD') }}
                                                        </div>
                                                    </template>

                                                    <template v-if="tab1" v-slot:[`item.terDate`]="{ item }">
                                                        <div v-if="item.terDate != null">{{ $moment(item.terDate).format('YYYY.MM.DD') }}</div>
                                                        <div v-else></div>
                                                    </template>
                                                    
                                                    <template v-if="tab2 && changeSelect == 1" v-slot:[`item.publickYn`]="{ item }">
                                                       {{item.publickYn == 1 ? "전체 공개":"멤버만 공개"}}
                                                    </template>

                                                    <template v-if="tab2" v-slot:[`item.groupName`]="{ item }">
                                                        <div class="multi-ellipsis-one" :title="item.groupName">
                                                            {{ item.groupName }}
                                                        </div>
                                                    </template>

                                                    <template v-if="tab2 && changeSelect == 2" v-slot:[`item.docGrade`]="{ item }">
                                                       {{item.docGrade == "SECRET" ? "비공개" : item.docGrade == "RESTRICT" ? "멤버만 공개" : "전체공개"}}
                                                    </template>

                                                    <template v-if="tab2" v-slot:[`item.joinDate`]="{ item }">
                                                       {{$moment(item.joinDate).format('YYYY.MM.DD')}}
                                                    </template> 
                                                    
                                                    <template slot="no-data">
                                                        <div class="nodata-txt-noicon">
                                                            <v-alert :value="true" v-if="tab1 && comp1 === true && comp2 === true">
                                                                {{$i18nUtil.trans("search.037","등록된 할 일이 없습니다.")}}
                                                            </v-alert>
                                                            <v-alert :value="true" v-else-if="tab1 && comp1 === true && comp2 === false">
                                                                {{$i18nUtil.trans("search.029","미완료된 할 일이 없습니다.")}}
                                                            </v-alert>
                                                            <v-alert :value="true" v-else-if="tab1 && comp1 === false && comp2 === true">
                                                                {{$i18nUtil.trans("search.031","완료된 할 일이 없습니다.")}}
                                                            </v-alert>
                                                            <v-alert :value="true" v-else-if="tab1 && comp1 === false && comp2 === false">
                                                                {{$i18nUtil.trans("search.037","등록된 할 일이 없습니다.")}}
                                                            </v-alert>
                                                            <v-alert :value="true" v-else-if="tab2 && changeSelect==1">
                                                                {{$i18nUtil.trans("search.034","등록된 과제가 없습니다.")}}
                                                            </v-alert>
                                                            <v-alert :value="true" v-else-if="tab2 && changeSelect==2">
                                                                {{$i18nUtil.trans("search.035","등록된 보드가 없습니다.")}}
                                                            </v-alert>
                                                        </div>
                                                    </template>
                                                </v-data-table>
                                                <div v-show="pageCount > 1" class="pagination">
                                                    <v-pagination
                                                        v-model="page"
                                                        circle
                                                        :length="pageCount"
                                                        :total-visible="7"
                                                        @input="tab1 ? getTodoUserList : getActivityList"
                                                    ></v-pagination>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modals-container></modals-container>
    </div>
</template>
<script>
import todoInfo from "@/components/cowork/general/board/todo/popup/TodoInfo.vue";
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import Datepicker from 'vuejs-datepicker';
import Treeselect from '@riophae/vue-treeselect'

export default {
    components: {
        Datepicker,
        UserTooltip,
        Treeselect,
    },
    data() {
        return {
            /* tenantId */
            tenantId: localStorage.getItem("tenantId"),
            selectedUserIndex: 0,
            ellipsisTimer: null,
            comp1: false,
            comp2: false,
            perform: '1',
            dayGbn: '1',
            currentIndex: '',
            dateFrom: new Date(this.$moment()),
            dateTo: new Date(this.$moment()),
            page: 1,
            pageCount: 0,
            itemsPerPage: 20,
            singleSelect: true,
            selected: [],
            selectHeader : [
                { text: this.$i18nUtil.trans("entity.todo.filter.paperTitle","Task(보드)"), align: 'center', value: 'paperTitle', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.content","할 일 내용"), align: 'center', value: 'todoTitle', sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.requester","요청자"), align: 'center', value: 'regUserName', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.expirationDate","만료일"),  align: 'center', value: 'todoEndDate', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.completionDate","완료일"),  align: 'center', value: 'terDate', sortable: true }
            ],
            todoHeaders: [
                { text: this.$i18nUtil.trans("entity.todo.filter.paperTitle","Task(보드)"), align: 'center', value: 'paperTitle', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.content","할 일 내용"), align: 'center', value: 'todoTitle', sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.requester","요청자"), align: 'center', value: 'regUserName', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.expirationDate","만료일"),  align: 'center', value: 'todoEndDate', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.completionDate","완료일"),  align: 'center', value: 'terDate', sortable: true }
            ],
            selectProjectHeaders:[
                { text: this.$i18nUtil.trans("entity.projectList.projectName","과제명"), align: 'center', value: 'groupName', sortable: true },
                { text: this.$i18nUtil.trans("message.filter.005","공개상태"), align: 'center', value: 'publickYn', sortable: false },
                { text: this.$i18nUtil.trans("title.TodoTeam.003","과제 가입일"),  align: 'center', value: 'joinDate', sortable: false }
            ],
            selectPaperHeaders:[
                { text: this.$i18nUtil.trans("entity.paper.filter.location","경로"), align: 'center', value: 'groupName', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.paperTitle","보드명"), align: 'center', value: 'paperTitle', sortable: true },
                { text: this.$i18nUtil.trans("message.filter.005","공개상태"),  align: 'center', value: 'docGrade', sortable: false },
                { text: this.$i18nUtil.trans("title.TodoTeam.004","보드 멤버 추가일"),  align: 'center', value: 'joinDate', sortable: false }
            ],
            changeTableData: false,
            userInfo: {},
            sortBy: 'paperTitle',
            sortDesc: false,
            quarterName: this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            quarter : [],
            todoTeamList: [],
            todoUserList: [],
            todoTeamExcelDownload: [],
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000,
                },
            },
            thisQuarterName: '',
            thisQuarterCd: '',
            thisQuarterIndex: '',
            quarterSelYn: 'N',
            /* Tree options */
            roleTypeUser: false,
            roleTLDTypeUser: false,
            teamDeptId: '',
            alwaysOpen: true,
            openOnClick: true,
            deptList : [],
            currentDeptId : "",
            currentDeptName : "",
            deptListSize : 0,
            gdpUser : false,
            gdpDeptId : "2030011050",
            gdpDeptName : "Global Digital Product실",
            gdpDeptList : [],

            tab1:true,
            tab2:false,
            // 과제/보드 목록 구분. 1:project 2:paper
            changeSelect : 1,
            currentTab1 : 1

        };
    },
    watch : {
        page : function() {
            if(this.changeTableData != true){
                this.changeTableData = true;
            }
            window.scrollTo(0, 0);
        },
        sortBy: {
            handler() {
                let obj = this;
                obj.page = 1;
                obj.pageCount = 0;
                obj.todoUserList = [];
                if(obj.changeTableData != true) {
                    obj.changeTableData = true;
                }
            }
        },
        sortDesc: {
            handler() {
                let obj = this;
                obj.page = 1;
                obj.pageCount = 0;
                obj.todoUserList = [];
                if(obj.changeTableData != true) {
                    obj.changeTableData = true;
                }
            }
        },
        changeTableData: {
            handler() {
                let obj = this;
                if(obj.changeTableData == true) {
                setTimeout(() => {
                    obj.changeTableData = false;
                    obj.selected = [];
                    if(obj.tab1){
                        obj.getTodoUserList();
                    }else{
                        obj.getActivityList();
                    }
                }, 500);
                }
            },
            deep: true
        }
    },
    created() {
        /* 분기 데이터 생성 */
        this.quarterCreate();
    },
    mounted() {
        this.multiElipsis(2);
        this.getUserInfo();
        this.checkRoleTLDTypeUser()
    },
    computed: {
        ...mapState("tree", ["treeData","userList", "userCount"]),
    },
    methods: {
        ...mapActions("modals", ["showToast", "showModal"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* TreeData 등록 */
        ...mapActions("tree", ["setOrgTree"]),
        /* TreeData 변경&수정 */
        ...mapMutations("tree", ["resetTreeList"]),
        ...mapMutations("tree", ["setTreeOfUserList"]),
        /* 할 일 상세 팝업 */
        todoInfoOpen(param) {
            const modalInfo = {
                name: "todoInfo",
                obj: this.$modal,
                component: todoInfo,
                width: "800px",
                todoId: param.todoId,
                todoMainId : param.todoMainId,
                receiverCount : param.receiverCount,
            };
            this.showModal(modalInfo);
        },
        /* 사용자 정보 조회 */
        getUserInfo() {
            let obj = this;
            let reqData = {
                url: "/api/auth/org/getUserInfo",
                method: "post",
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.result !== null) {
                    if(res.result.errorCode !== undefined) {
                    } else {
                        obj.userInfo = res.result.orgDeptUserView;
                        obj.teamDeptId = res.result.orgDeptUserView.deptId;
                        obj.currentDeptId = obj.teamDeptId;
                        if(obj.$i18nUtil.getLanguage() === 'ko') {
                            obj.currentDeptName = obj.userInfo.deptName;
                        }else{
                            obj.currentDeptName = obj.userInfo.deptNameEn != null ? obj.userInfo.deptNameEn : obj.userInfo.deptName;
                        }
                        obj.getGdpDept();
                    }
                }
            }).catch(function(err) {
                console.log(err);
            });
        },
        /* GDP 부서 리스트 조회 */
        getGdpDept() {
            let obj = this;
            let reqData = {
                url : "/api/org/getDeptList",
                method : "post",
                params : {
                    companyId : obj.userInfo.companyId,
                    parentDeptId : obj.gdpDeptId,
                }
            };
            //프로그레스바 시작
            obj.showLoadingbar();
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (data) {
                //프로그레스바 종료
                obj.hideLoadingbar();
                let gdpList = data.result.treeList;
                gdpList.forEach(function(item, index, arr) {
                    obj.gdpDeptList.push(item.deptId);
                });
                obj.getOrgDeptList();
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        /* 겸직 사용자 & TB_PAPER_TODO_USER_LIST의 INCLUDE 사용자 deptId,deptName 조회 */
        getOrgDeptList() {
            let obj = this;
            let reqData = {
                url : "/api/copaper/todo/getOrgDeptUserList",
                method : "post",
                params : {}
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                if(res.errorCode != null) {
                    console.log(res.errorCode);
                } 
                else {
                    if(res.result.length > 1) { // 겸직 일 때
                        obj.deptListSize = res.result.length;
                        obj.currentDeptId = res.result[0].substring(res.result[0].indexOf(":")+1);
                        obj.currentDeptName = res.result[0].slice(0, res.result[0].indexOf(":"));
                        obj.userInfo.deptName = obj.currentDeptName;
                        obj.userInfo.deptId = obj.currentDeptId;
                        obj.teamDeptId = obj.currentDeptId;
                        for(let i in res.result) {
                            if(i == 0){
                                obj.deptList.unshift(res.result[i]);
                            } else {
                                obj.deptList.push(res.result[i]);
                            }
                        }
                        obj.gdpDeptList.forEach(function(item) {
                            if(obj.currentDeptId == item) { // 겸직 부서중 기본 부서가 Global Digital Product에 포함되어 있으면 Gdp 조직도 활성화.
                                obj.gdpUser = true;
                                obj.userInfo.deptId = obj.gdpDeptId;
                                obj.userInfo.deptName = obj.gdpDeptName;
                            }
                        });
                        if(obj.gdpUser){
                            obj.getTreeData();
                        }
                    } else { // 겸직 아닐 때
                        obj.gdpDeptList.forEach(function(item) {
                            if(obj.userInfo.deptId == item) { // 기본 부서가 Global Digital Product에 포함되어 있으면 Gdp 조직도 활성화.
                                obj.gdpUser = true;
                                obj.userInfo.deptId = obj.gdpDeptId;
                                obj.userInfo.deptName = obj.gdpDeptName;
                            }
                        });
                        if(obj.gdpUser){
                            obj.getTreeData();
                        }
                    }
                    obj.checkRoleTypeUser();
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        /* 임원권한 확인 */
        checkRoleTypeUser() {
            let obj = this;
            let reqData = {};
            reqData.params = {
                roleType: "EXE",
            };
            reqData.url = "/api/org/checkRoleTypeUser";
            reqData.method = "post";            
            
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                obj.roleTypeUser = res.result;              
            }).then(function(res){
                if(obj.roleTypeUser) {
                    obj.getTreeData();
                }
                obj.getTodoTeamList();
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        /* 팀장권한 확인 */
        checkRoleTLDTypeUser() {
            let obj = this;
            let reqData = {};
            reqData.params = {
                roleType: "TLD",
            };
            reqData.url = "/api/org/checkRoleTypeUser";
            reqData.method = "post";            
            
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                obj.roleTLDTypeUser = res.result;              
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        /* Global Digital Product 부서 확인 */
        // checkGdpUser() {
        //     let obj = this;
        //     let reqData = {};
        //     reqData.params = {
        //         roleType: "EXE",
        //     };
        //     reqData.url = "/api/copaper/todo/checkGdpUser";
        //     reqData.method = "post";            
        //     //프로그레스바 시작
        //     obj.showLoadingbar();
        //     obj.COWORK_REST_SIMPLE_ACTION(reqData)
        //     .then(function(res) {
        //         //프로그레스바 종료
        //         obj.hideLoadingbar();
        //         if(res.result.deptId != undefined && res.result.deptName != undefined)  {
        //             obj.gdpDeptId = res.result.deptId;
        //             obj.gdpDeptName = res.result.deptName;
        //         }
        //         obj.checkGdpDept();
        //     })
        //     .catch(function(err) {
        //         console.log(err);
        //     });
        // },
        /* 현재날짜 기준으로 분기 생성
            (지난해 1~4분기, 올해 현재분기까지, 현재분기+1분기)
        */
        quarterCreate() {
            
            for(var i=this.$moment().format('Q'); i > 0 ;i--) {
                let strMonth1 = (i*3)-2;
                // 현재 분기 + 1 push , 현재분기 데이터 세팅 
                if(i == this.$moment().format('Q')) {
                    if(this.$moment().format('Q') == 4) { // 다음해 년도 
                        this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(-1, "years").format('YYYY'), quarter: 1}), quarterCd:this.$moment().subtract(-1, "years").format('YYYY')+'01'});
                    } else {
                        let q = (i*1)+1;
                        let strMonth2 = (q*3)-2;

                        if(strMonth2 >= 10) {
                            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: q}), quarterCd:this.$moment().format('YYYY')+strMonth2});
                        } else {
                            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: q}), quarterCd:this.$moment().format('YYYY')+'0'+strMonth2});
                        }
                    }
                    // 현재 분기 데이터 세팅.
                    if(strMonth1 >= 10) {  // 4분기
                        // this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i}), quarterCd:this.$moment().format('YYYY')+strMonth1});
                        this.thisQuarterName = this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i});
                        this.thisQuarterCd = this.$moment().format('YYYY')+strMonth1;
                        this.thisQuarterIndex = this.quarter.length;
                    } else {  // 1, 2, 3 분기 
                        // this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i}), quarterCd:this.$moment().format('YYYY')+'0'+strMonth1});
                        this.thisQuarterName = this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i});
                        this.thisQuarterCd = this.$moment().format('YYYY')+'0'+strMonth1;
                        this.thisQuarterIndex = this.quarter.length;
                    }
                }
                
                // 올해 현재분기까지 역순 push
                if(strMonth1 >= 10) {
                    this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i}), quarterCd:this.$moment().format('YYYY')+strMonth1});
                } else {
                    this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i}), quarterCd:this.$moment().format('YYYY')+'0'+strMonth1});
                }
                
            }

            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 4}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'10'});
            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 3}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'07'});
            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 2}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'04'});
            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 1}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'01'});
        },
        /* 시작일 변경 이벤트 */
        dateFromChange(date) {
            this.$nextTick(() => {
                this.page = 1;
                this.pageCount = 0;
                this.todoTeamList = [];
                this.todoUserList = [];
                if(this.dayGbn === '1') {
                    this.dateTo = this.dateFrom;
                } else if(this.dayGbn === '2') {
                    this.dateFrom = this.$moment(this.dateFrom).day("Monday").format('L');
                    this.dateTo = this.$moment(this.dateFrom).day("Monday").subtract(-6, "days").format('L');
                }
                this.getTodoTeamList();
            })
        },
        /* 종료일 변경 이벤트 */
        dateToChange(date) {
            this.$nextTick(() => {
                this.page = 1;
                this.pageCount = 0;
                this.todoTeamList = [];
                this.todoUserList = [];
                if(this.dayGbn === '1') {
                    this.dateFrom = this.dateTo;
                } else if(this.dayGbn === '2') {
                    this.dateFrom = this.$moment(this.dateTo).day("Monday").format('L');
                    this.dateTo = this.$moment(this.dateTo).day("Monday").subtract(-6, "days").format('L');
                }
                this.getTodoTeamList();
            })
        },
        /* 일버튼 클릭 이벤트 */
        daySel() {
            this.page = 1;
            this.pageCount = 0;
            this.todoTeamList = [];
            this.todoUserList = [];
            this.dayGbn = '1';
            this.quarterName = this.$i18nUtil.trans("entity.todo.filter.quarter","분기");
            this.currentIndex = '';
            this.dateFrom = this.$moment().format('L');
            this.dateTo = this.$moment().format('L');
            this.getTodoTeamList();
            this.quarterSelYn = 'N';
        },
        /* 주버튼 클릭 이벤트 */
        weekSel() {
            this.page = 1;
            this.pageCount = 0;
            this.todoTeamList = [];
            this.todoUserList = [];
            this.dayGbn = '2';
            this.quarterName = this.$i18nUtil.trans("entity.todo.filter.quarter","분기");
            this.currentIndex = '';

            this.dateFrom = this.$moment().day("Monday").format('L');
            this.dateTo = this.$moment().day("Monday").subtract(-6, "days").format('L');
            this.getTodoTeamList();
            this.quarterSelYn = 'N';
        },
        /* 분기버튼 이벤트 */
        quarterSelBtn() {
            this.page = 1;
            this.pageCount = 0;
            this.todoTeamList = [];
            this.todoUserList = [];
            this.dayGbn = '0';
            $("input:radio[name=period]").prop("checked",false);
            this.quarterName = this.thisQuarterName;
            this.currentIndex = this.thisQuarterIndex;
            this.dateFrom = this.$moment(this.thisQuarterCd+'01').format('L');
            this.dateTo = this.$moment(this.thisQuarterCd+this.$moment(this.thisQuarterCd+'01').subtract(-2, "months").endOf('month').format('DD')).subtract(-2, "months").format('L');
            this.getTodoTeamList();
            this.quarterSelYn = 'Y';
        },
        /* 분기선택 이벤트 */
        quarterSel(item, index) {
            this.page = 1;
            this.pageCount = 0;
            this.todoTeamList = [];
            this.todoUserList = [];
            this.dayGbn = '0';
            $("input:radio[name=period]").prop("checked",false);
            this.quarterName = item.quarterName;
            this.currentIndex = index;
            this.dateFrom = this.$moment(item.quarterCd+'01').format('L');
            this.dateTo = this.$moment(item.quarterCd+this.$moment(item.quarterCd+'01').subtract(-2, "months").endOf('month').format('DD')).subtract(-2, "months").format('L');
            this.getTodoTeamList();
        },
        /* 조회조건 클릭 이벤트(수행기간/완료일, 미완료/완료) */
        searchClick() {
            this.page = 1;
            this.pageCount = 0;
            this.todoTeamList = [];
            this.todoUserList = [];
            this.getTodoTeamList();
        },
        /* 조회조건 클릭 이벤트(과제 목록 / 보드 목록 ) */
        searchClick2() {
            if(this.changeSelect == 1){
                this.sortBy = "groupName";
                this.selectHeader = this.selectProjectHeaders;
            }else{
                this.sortBy = "paperTitle";
                this.selectHeader = this.selectPaperHeaders;
            }
            this.page = 1;
            this.pageCount = 0;
            this.todoTeamList = [];
            // this.todoUserList = [];
            this.activityList = [];
            this.getTodoTeamList();
        },
        /* 사용자 할 일 클릭 이벤트 */
        todoUserClick(index) {
            this.page = 1;
            this.pageCount = 0;
            this.todoUserList = [];
            this.selectedUserIndex = index;
            if(this.tab1){
                this.getTodoUserList();
            }else{
                this.getActivityList();
            }
        },
        /* 팀원별 할 일 갯수 조회 */
        getTodoTeamList() {
            let obj = this;
            let compGbn = 0;

            if(obj.comp1 === true && obj.comp2 === false) {
                compGbn = 1;
            } else if(obj.comp1 === false && obj.comp2 === true) {
                compGbn = 2;
            }

            let reqData = {};
            reqData.params = {
                startDate: obj.$moment(this.dateFrom).format("YYYYMMDD"),
                endDate: obj.$moment(this.dateTo).format("YYYYMMDD"),
                performGbn: obj.perform,
                compGbn: compGbn,
                deptId: obj.teamDeptId,
            };

            if(this.tab2){
                reqData.params.changeTab  = obj.changeSelect == 1 ? 'project' : 'paper';
            }
            
            reqData.url = "/api/copaper/todo/getTodoTeamList";
            reqData.method = "post";

            //프로그레스바 시작
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => {
                    //프로그레스바 종료
                    this.hideLoadingbar();
                    if (res.errorCode) {
                        console.log(res.errorCode);
                    } else {
                        let list = res.result.todoTeamList;
                        list.forEach(item => {
                            if(obj.$i18nUtil.getLanguage() === 'ko') {

                            }else{
                                item.USER_NAME = item.USER_NAME_EN != null ? item.USER_NAME_EN : item.USER_NAME;
                            }
                        })
                        obj.todoTeamList = list
                        if(this.tab1){
                            obj.getTodoUserList();
                        }else{
                            obj.getActivityList();
                        }
                            
                    }
                }).then((e) => {
                    const scrollTeam = document.getElementById("scrollTeam");
                    let activeScrollTeam = $('li').filter('.active')[0].offsetTop;
                    scrollTeam.scrollTop = activeScrollTeam;
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
        /* 팀원 할 일 목록 조회 */
        getTodoUserList() {
            let obj = this;
            let compGbn = 0;

            if(obj.comp1 === true && obj.comp2 === false) {
                compGbn = 1;
            } else if(obj.comp1 === false && obj.comp2 === true) {
                compGbn = 2;
            }

            let reqData = {};
            reqData.params = {
                currentPage: obj.page,
                itemsPerPage: obj.itemsPerPage,
                startDate: obj.$moment(this.dateFrom).format("YYYYMMDD"),
                endDate: obj.$moment(this.dateTo).format("YYYYMMDD"),
                performGbn: obj.perform,
                compGbn:compGbn,
                userId:obj.todoTeamList[obj.selectedUserIndex].USER_ID,
                sortBy:obj.sortBy,
                sortDesc:obj.sortDesc,
            };
            reqData.url = "/api/copaper/todo/getTodoUserList";
            reqData.method = "post";

            //프로그레스바 시작
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => {
                //프로그레스바 종료
                this.hideLoadingbar();
                if (res.errorCode) {
                    console.log(res.errorCode);
                } else {
                    // obj.todoUserList = res.result.todoUserList;
                    let list = res.result.todoUserList;
                    list.forEach(item => {
                        if(obj.$i18nUtil.getLanguage() === 'ko') {

                        }else{
                            item.regUserName = item.regUserNameEn != null ? item.regUserNameEn : item.regUserName;
                            item.chargerName = item.chargerNameEn != null ? item.chargerNameEn : item.chargerName;
                        }
                    })
                    obj.todoUserList = list
                    obj.pageCount = res.result.todoUserListPageCount;
                    const scrollUser = document.getElementById("scrollUser");
                    scrollUser.scrollTop = 0;
                }
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
        /* 팀원 과제/보드 현황 조회 */
        getActivityList() {
            let obj = this;
            let reqData = {};
            reqData.params = {
                currentPage: obj.page,
                itemsPerPage: obj.itemsPerPage, 
                userId:obj.todoTeamList[obj.selectedUserIndex].USER_ID,
                sortBy:obj.sortBy,
                sortDesc:obj.sortDesc,
            };
            if(obj.changeSelect == 1){
                reqData.url = "/api/cogroup/geActivityProjectList";
            }else{
                reqData.url = "/api/copaper/paper/getActivityPaperList";
            }
            reqData.method = "post";

            // 프로그레스바 시작
            this.showLoadingbar();
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => {
                //프로그레스바 종료
                this.hideLoadingbar();
                if (res.errorCode) {
                    console.log(res.errorCode);
                } else {
                    if(obj.changeSelect == 2){
                        res.result.list.content.forEach(function(data){
                            if(data.joinDate == null){
                                res.result.joinDate.forEach(function(data2){
                                    if(data2.groupId == data.groupId){
                                        data.joinDate = data2.joinDate;
                                        return;
                                    }
                                })
                            }
                        })
                    }

                    let list = res.result.list.content;
                    list.forEach(item => {
                        if(obj.$i18nUtil.getLanguage() === 'ko') {

                        }else{
                            item.regUserName = item.regUserNameEn != null ? item.regUserNameEn : item.regUserName;
                            item.chargerName = item.chargerNameEn != null ? item.chargerNameEn : item.chargerName;
                        }
                    })
                    obj.todoUserList = list;
                    obj.pageCount = res.result.list.totalPages;
                    const scrollUser = document.getElementById("scrollUser");
                    scrollUser.scrollTop = 0;
                }
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
        /* 팀원 과제/보드 목록 팝업 */
        changeTab(tab) {
            if(tab == 1){
                this.tab1 = true;
                this.tab2 = false;
                this.selectHeader = this.todoHeaders;
                this.sortBy = "paperTitle";
            }else{
                this.tab1 = false;
                this.tab2 = true;
                if(this.changeSelect == 1){
                    this.sortBy = "groupName";
                    this.selectHeader = this.selectProjectHeaders;
                }else{
                    this.sortBy = "paperTitle";
                    this.selectHeader = this.selectPaperHeaders;
                }
            }
            this.todoUserList = [];
            this.getTodoTeamList();
        },
        /* 팀원 할 일 엑셀 다운로드 */
        getTodoTeamExcelDownload() {
            let obj = this;
            let compGbn = 0;

            if(obj.comp1 === true && obj.comp2 === false) {
                compGbn = 1;
            } else if(obj.comp1 === false && obj.comp2 === true) {
                compGbn = 2;
            }

            let reqData = {};
            reqData.params = {
                currentPage: obj.page,
                itemsPerPage: obj.itemsPerPage,
                startDate: obj.$moment(this.dateFrom).format("YYYYMMDD"),
                endDate: obj.$moment(this.dateTo).format("YYYYMMDD"),
                performGbn: obj.perform,
                compGbn:compGbn,
                deptId: obj.teamDeptId,
            };

            //프로그레스바 시작
            this.showLoadingbar();
            obj.$axios({
                url: "/api/copaper/todo/getTodoTeamExcelDownload",
                responseType: "blob",
                headers: {
                    "Content-Type": "application/json"
                },
                method: "post",
                data: reqData.params
            }).then(res => {
                let fileName = this.$i18nUtil.trans("message.TodoTeam.007","팀원할일목록");
                let blob = new Blob([res.data], {
                    type: res.headers["content-type"]
                });

                if(this.dayGbn === "0") {
                    fileName += this.quarterName;
                    fileName = fileName.replace(" ", "_");
                } else if(this.dayGbn === "1") {
                    fileName += reqData.params.startDate;
                } else if(this.dayGbn === "2") {
                    fileName += reqData.params.startDate + "_" + reqData.params.endDate;
                }

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, fileName+".xlsx");
                } else {
                    let link = document.createElement("a");
                    link.target = "_self";
                    link.setAttribute("download", fileName+".xlsx");
                    link.href = window.URL.createObjectURL(blob);
                    link.click();
                    link.remove();
                }
                this.hideLoadingbar();
            })
            .catch(err => {
                //프로그레스바 종료 
                this.hideLoadingbar();
                console.log("axios err => ", err);
            });
        },
        /* IE도 적용되는 말줄임 처리 */
        multiElipsis(ellipsisLine) {
            if (this.ellipsisTimer) {
                clearTimeout(this.ellipsisTimer);
            }

            this.ellipsisTimer = setTimeout(function () {
                if ($(".multi-ellipsis").length > 0) {
                var omle = $(".multi-ellipsis");
                var $txtR = $("<div class='txtEllipsis'></div>");
                var $body = $("body");
                omle.each(function (idx) {
                    var _this = $(this);
                    var orinalWidth = $(this).width();
                    var txtOmle = _this.text();

                    $txtR.text(txtOmle);
                    $body.append($txtR);

                    if ($txtR.width() >= orinalWidth * 1.2) {
                    _this.addClass("no-ellipsis");
                    } else {
                    _this.removeClass("no-ellipsis");
                    }
                });
                }
            }, 250);
            setTimeout(function () {
                $(".txtEllipsis").remove();
            }, 1000);
        },
        moveLocation(location) {
            window.open("/general/board/" + location, "_blank");
        },
        /* 최초 트리 데이터 조회 */
        getTreeData() {
            let area = document.getElementsByClassName("vue-treeselect__control");
            for (let i = 0; i < area.length; i++) {
                area[i].style.display = "none";
            }
            this.resetTreeList(null);

            let obj = this;
            let reqData = {
                url : "/api/org/getDeptList",
                method : "post",
                params : {
                    companyId : obj.userInfo.companyId,
                    parentDeptId : obj.userInfo.deptId,
                }
            };
            //프로그레스바 시작
            obj.showLoadingbar();
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (data) {
                //프로그레스바 종료
                obj.hideLoadingbar();
                /* treeData set */
                let rootNode = data.result.rootNode;
                let treeList = data.result.treeList;
                if(rootNode === undefined) {
                    rootNode = {deptId: obj.userInfo.deptId, deptName: obj.userInfo.deptName};
                }                
                obj.setOrgTree({
                    rootNode: rootNode,
                    treeList: treeList,
                    parentNode: null,
                });
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        /* 노드 오픈 */
        async handleOpenNode({ action, parentNode, callback }) {
            //await this.$emit("openNode", { parentNode: parentNode, companyId: null });
            let nodeList = [];
            let obj = this;
            let reqData = {
                url : "/api/org/getDeptList",
                method : "post",
                params : {
                    parentDeptId : parentNode.id,
                    companyId : obj.userInfo.companyId
                }
            };
            await obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                if(res.errorCode != null) {
                } else {
                    let treeList = res.result.treeList;
                    
                    treeList.forEach(function(item, index, arr) {
                        let node = item;
                        let childYn = node.childYn;
                        let nodeInfo = {
                            id: node.deptId,
                            label: node.deptName
                        };
                        if (childYn > 0) {
                            nodeInfo.children = null;
                        }
                        nodeList.push(nodeInfo);
                    });
                }
            })
            .catch(function (err) {
                console.log(err);
            });
            parentNode.children = nodeList;
        },
        /* 노드(부서) 선택 시 */
        handleSelectNode(node, instanceId) {
            this.teamDeptId = node.id;
            this.userInfo.deptName = node.label;
            this.currentDeptId =  this.teamDeptId;
            this.currentDeptName =  this.userInfo.deptName;
            this.getTodoTeamList();
            //this.checkDepts.push(node);
            this.$emit("selectNode", { node: node, instanceId: instanceId });
        },
        /* 노드(부서) 선택 해제 시 */
        handleDeSelectNode(node, instanceId) {
            this.$emit("deSelectNode", { node: node, instanceId: instanceId });
        },
        /* 부서 변경 시 조직도 트리 호출 */
        changeDept(tab){
            let obj = this;
            obj.gdpUser = false;
            obj.currentDeptName = tab.split(":")[0];
            obj.currentDeptId = tab.split(":")[1];
            obj.userInfo.deptName = obj.currentDeptName;
            obj.userInfo.deptId = obj.currentDeptId;
            obj.teamDeptId = obj.currentDeptId;
            obj.gdpDeptList.forEach(function(item) {
                if(obj.currentDeptId == item) { // 변경한 부서가 Global Digital Product에 포함되어 있으면 Gdp 조직도 활성화.
                    obj.gdpUser = true;
                    obj.userInfo.deptId = obj.gdpDeptId;
                    obj.userInfo.deptName = obj.gdpDeptName;
                }
            });
            obj.getTreeData();
            obj.getTodoTeamList();
        },
    },
}
</script>
<style>
.calendar_box .vdp-datepicker input:disabled {
    cursor: default;
}
</style>
<style scoped>
#modals-container >>> .v--modal-overlay .v--modal-box {
  overflow: visible;
}
.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}

.multi-ellipsis-one {
  overflow: hidden;
  position: relative;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis-one:before,
.multi-ellipsis-one:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis-one:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis-one.no-ellipsis::before,
.multi-ellipsis-one.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis-one {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 1;
  }
  .multi-ellipsis-one::before,
  .multi-ellipsis-one::after {
    content: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/TodoTeam.vue